import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports.service';
import { UtilsService } from '../services/utils.service';

@Component({
  selector: 'app-inactive-workers-report',
  templateUrl: './inactive-workers-report.component.html',
  styleUrls: ['./inactive-workers-report.component.css']
})
export class InactiveWorkersReportComponent implements OnInit {

  cutoff: string = '';
  fetching: boolean = false;
  inactiveWorkers: InactiveWorkers[] = [];
  errorMessage: string = '';

  constructor(private reportsService: ReportsService, private utilService: UtilsService) { }

  ngOnInit(): void {
  }

  getInactiveWorkers() {
    this.fetching = true;
    this.errorMessage = '';
    this.reportsService.getInactiveWorkersReport(this.cutoff).subscribe({
      next: (data: InactiveWorkers[]) => {
        this.fetching = false;
        this.inactiveWorkers = data;
      },
      error: (error) => {
        console.error('Error fetching inactive workers report:', error);
        this.fetching = false;
        this.errorMessage = error?.error?.detail || 'An error occurred while fetching the report.';
      }
    });
  }

  exportTableToCSV(tableId) {
    const filename = `Inactive Workers Report since ${this.cutoff}.csv`;
    let csv = this.utilService.extractTableData(tableId);
    this.utilService.downloadAsCSV(csv.join('\n'), filename);
  }

}
